import { db } from '@app/icare/client/db'
import { localCountQueryOptions, localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import type { PatientIdType } from '@app/icare/entities/patient/schema/PatientId'
import dayjs from 'dayjs'

export const patientSeparateResidenceQueries = {
  /** Active relations only — used by the tab bar. */
  forTabs: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientSeparateResidence'] } },
      query: db
        .selectFrom('patientSeparateResidence')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .where(eb => eb.or([eb('activeTo', 'is', null), eb('activeTo', '>=', dayjs().format('YYYY-MM-DD'))]))
        .orderBy('activeFrom', 'asc'),
    }),

  /** Total count of active + inactive relations — used by the tab bar. */
  totalCount: (patientId: PatientIdType) =>
    localCountQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientSeparateResidence'] } },
      query: db
        .selectFrom('patientSeparateResidence')
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null),
    }),

  /** Bare columns — used by the historical index table. */
  forIndex: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientSeparateResidence'] } },
      query: db
        .selectFrom('patientSeparateResidence')
        .select(['id', 'type', 'toId', 'firstName', 'lastName', 'address', 'activeFrom', 'activeTo', 'deletedAt'])
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null),
    }),
}
